import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../../Base/Components/Loader/Loader";
import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { useForm } from "../../../../Base/Hooks/useForm";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { ObtenerCurrency } from "../../../../Base/API/Global/Currency/CurrencyRequest";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getDateTimeStringSQL } from "../../../../Base/Services/Moment/Luxon";

// ------------------- CONSULTAS A LA API---------------------------
import { getProveedorAct } from "../../../../API/Compras/Proveedores/ProveedoresRequest";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { getTasaCambio } from "../../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import { getTiposIngreso } from "../../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import { getCuentasHijas } from "../../../../API/Finanzas/Retencion/ConceptoRetencionRequest";
import { getRangosDocumentosPorID } from "../../../../API/Finanzas/RegistroContable/RangosDocumentosRequest";
import { AplicarNota, EditarNotaCreditoProveedor, eliminarDetalles, getDetallesPorId, getEncabezadoPorId, GuardarNotaCreditoProveedor } from "../../../../API/Finanzas/NotasProveedores/NotasProveedoresRequest";

import OverlayIngresos from "./OverlayIngresos";
import OrdenesComprasReporte1 from "../../../ERP/Compras/OrdenesCompras/Reporte/OrdenesComprasReporte1";


const NotaCreditoProveedorCRUD = ({
  showDialog,
  setShowDialog,
  selectedEnc,
  setSelectedEnc,
  getInfo,
  habilitar,
  setHabilitar,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [estados, setEstados] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [tipoIngresos, setTipoIngresos] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [selectedFacturas, setSelectedFacturas] = useState([]);
  const [cuentasDetalles, setCuentasDetalles] = useState([]);
  const [showDialogReporte, setShowDialogReporte] = useState(false);
  const [Languaje, setLanguaje] = useState('es');
    

  const initialValues = {
    IdNotaCreditoEnc: -1,
    NumeroNota: '',
    Memo: '',
  };

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    setSelected([])

    const proveedorTempo = await getProveedorAct()
    setProveedores(proveedorTempo)

    const estadosTempo = await getEstadosCategory('NotaCreditoProveedor')
    setEstados(estadosTempo?.filter(i => i.IdStatus !== 96 && i.IdStatus !== 97))

    const monedasTempo = await ObtenerCurrency()
    setMonedas(monedasTempo)

    const tasaCambioTempo = await getTasaCambio()

    const tipoIngresoTempo = await getTiposIngreso()
    setTipoIngresos(tipoIngresoTempo)

    const cuentasTempo = await getCuentasHijas()
    setCuentas(cuentasTempo)

    const rangoAct = await getRangosDocumentosPorID(38)
    const rangoExo = await getRangosDocumentosPorID(49)
    setCuentasDetalles(
      cuentasTempo.map((c) => {
        return {
          IdCuenta: c.IdAccount,
          CuentaDetalle: c.NombreCuenta,
          Account: c.Account,
          CodigoAccount: c.CodigoAccount,
          IdContenedorAccount: c.IdContenedorAccount,
          IdSubCategoria: c.IdSubCategoria,
          CuentaAlgodon: c.NombreCuenta,
          Type: c.Type,
          cca: c.cca,
          codeS: c.codeS,
        };
      })
    );
    

    if (selectedEnc?.length > 0) {
      setHabilitar(false)
      let IdNotaCreditoEnc = selectedEnc[0]?.IdNotaCreditoEnc


      const encabezadoTempo = await getEncabezadoPorId(IdNotaCreditoEnc)
      let IdCountry = encabezadoTempo[0]?.IdCountry;
      let cuenta
      if (IdCountry === 95) {
        cuenta = cuentasTempo?.find((i) => i.IdAccount === 15);
      } else {
        cuenta = cuentasTempo?.find((i) => i.IdAccount === 16);
      }

      setValues({
        ...encabezadoTempo[0],
        FechaEmisionStr: new Date(encabezadoTempo[0]?.FechaEmisionStr),
        IdCuentaDebito: cuenta,
        NombreCuenta: cuenta,
      })

      const tempoDetalles = await getDetallesPorId(IdNotaCreditoEnc)
      const a = tempoDetalles.map((d) => {
        const cuentaEncontrada = cuentasTempo.find((c) => c.IdAccount === d.IdCuenta)
        return {
          ...d,
          CuentaDetalle: cuentaEncontrada?.NombreCuenta || '',
          TipoNotaCredito: d.IdTipoNotaCredito 
            ? tipoNotaCredito.find((t) => t.IdTipoNotaCredito === d.IdTipoNotaCredito)?.TipoNotaCredito 
            : null
        }
      })
      setDetalles(a)

    } else {
      setValues({
        ...initialValues,
        IdStatus: 93,
        StatusName: "Pendiente",
        TasaCambio: tasaCambioTempo[0]?.TasaCambio,
        IdRango: rangoAct[0]?.IdRango,
        IdExoneracion: rangoExo[0]?.IdRango
      })
      setDetalles([])
    }


    setLoading(false);
  };

  const getNuevaNota = async () => {
    setLoading(true);
    setSelectedEnc([])
    setHabilitar(true)

    const tasaCambioTempo = await getTasaCambio()

    setValues({
      ...initialValues,
      IdStatus: 93,
      StatusName: "Pendiente",
      TasaCambio: tasaCambioTempo[0]?.TasaCambio,
    })
    setDetalles([])


    setLoading(false);
  };

  const tipoNotaCredito = [
    {
      TipoNotaCredito: "Devolución",
      IdTipoNotaCredito: 1,
    },
    {
      TipoNotaCredito: "Cambio de Precio",
      IdTipoNotaCredito: 2,
    },
    {
      TipoNotaCredito: "Diferencial Cambiario",
      IdTipoNotaCredito: 3,
    },
  ];

  const verificarCampos = () => {
    let err = false;

    if (!values?.NumeroNota) {
      err = true;
      toastShow(toast, "error", "Error", "No.Nota es requerido.");
      return;
    }
    if (!values?.CustomerName && !values?.IdVendor) {
      err = true;
      toastShow(toast, "error", "Error", "Proveedor es requerido.");
      return;
    }
    if (!values?.FechaEmisionStr) {
      err = true;
      toastShow(toast, "error", "Error", "La fecha de emisión es requerida.");
      return;
    }
    if (!values?.Currency && !values?.IdCurrency) {
      err = true;
      toastShow(toast, "error", "Error", "Moneda es requerida.");
      return;
    }
    if (!values?.Monto) {
      err = true;
      toastShow(toast, "error", "Error", "No.Nota es requerido.");
      return;
    }
    if (!values?.Inventario && !values?.IdTipoIngreso) {
      err = true;
      toastShow(toast, "error", "Error", "Inventario es requerido.");
      return;
    }

    if (detalles.length > 0) {
      detalles.forEach((l) => {
        if (!l.IdTipoNotaCredito) {
          toastShow(toast, 'error', 'Error', 'Debe seleccionar el tipo de nota de crédito en todos los detalles')
          err = true
          return
        }
      });

      detalles.forEach((l) => {
        if (!l.IdCuenta) {
          toastShow(toast, 'error', 'Error', 'Debe seleccionar una cuenta en todos los detalles')
          err = true
          return
        }
      })
    }

    return !err;
  };
  
  const guardarNota = async () => {
    if(verificarCampos()){

      let tempoMontoD;
      let tempoMontoL;
      if (values.IdMoneda === 1) {
        tempoMontoL = values.Monto * values.TasaCambio;
        tempoMontoD = values.Monto;
      } else {
        tempoMontoL = values.Monto;
        tempoMontoD = values.Monto / values.TasaCambio;
      }
      setValues({ ...values, MontoL: tempoMontoL, MontoD: tempoMontoD });

      let encabezado = {
        ...values,
        FechaEmision: getDateTimeStringSQL(new Date(values.FechaEmisionStr)),
        IdUserEdit: userAuth?.IdUser,
        IdUserCreate: userAuth?.IdUser,
        MontoD: tempoMontoD,
        MontoL: tempoMontoL,
        IdCuentaCredito: values?.IdCuentaCredito,
        IdCuentaDebito: values?.IdCuentaDebito?.IdAccount || values?.IdCuentaDebito,
        IdVendor: values?.CustomerName?.IdVendor || values?.IdVendor,
        IdCurrency: values?.Currency?.IdCurrency || values?.IdCurrency,
        IdTipoIngreso: values?.Inventario?.IdTipoIngreso || values?.IdTipoIngreso,
        IdStatus: values?.StatusName?.IdStatus || values?.IdStatus,
        IdRango: values?.IdRango,
        IdExoneracion: values?.IdExoneracion,
      }
      let message = <div>¿Está seguro que desea guardar la información?</div>
      console.log(encabezado);
      confirmDialog({
        message: message,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          setLoading(true);
          if(encabezado.IdNotaCreditoEnc <= 0){
            const resp = await GuardarNotaCreditoProveedor(encabezado, detalles);
            if(resp[0]?.ESTADO === 1){
              toastShow(toast, "success", "Guardada", resp[0]?.MENSAJE);
              setTimeout(() => {
                setShowDialog(false);
              }, 700);
              getInfo()
              setSelectedEnc([])
            }else{
              toastShow(toast, "error", "Error", 'Error al guardar la nota de crédito');
            }
          }else{
            const resp = await EditarNotaCreditoProveedor(encabezado, detalles);
            if(resp[0]?.ESTADO === 1){
              toastShow(toast, "success", "Editada", resp[0]?.MENSAJE);
              setTimeout(() => {
                setShowDialog(false);
              }, 700);
              getInfo()
              setSelectedEnc([])
            }else{
              toastShow(toast, "error", "Error", 'Error al editar la nota de crédito');
            }
          }
          setLoading(false);
        },
        reject: () => {},
      });
    }
  };

  const agregarNuevaFila = (infoIngreso) => {
    let newRow = [...detalles];
  
    let FacturaExistente = detalles.some((i) =>
      infoIngreso.some((f) => i.IdIngresoDetalle === f.IdIngresoDetalle && i.Factura === f.Factura)
    );
  
    if (FacturaExistente) {
      toastShow(toast, "error", "Error", "No se permiten valores repetidos");
    } else {
      let dataNueva = [];
  
      infoIngreso.forEach((f) => {
        let Id = (detalles.length + dataNueva.length + 1) * (-1);
  
        const nuevoDetalle = {
          IdNotaCreditoDet: Id,
          IdNotaCreditoEnc: values.IdNotaCreditoEnc,
          IdStatus: 75,
          IdIngresoDetalle: f.IdIngresoDetalle,
          IdTipoIngreso: values?.Inventario?.IdTipoIngreso || values?.IdTipoIngreso,
  
          PrecioFD: f.PrecioD,
          PrecioFL: f.PrecioL,
          PrecioD: f.PrecioD,
          PrecioL: f.PrecioL,
  
          MontoFD: f.MontoD,
          MontoFL: f.MontoL,
          MontoL: f.MontoL,
          MontoD: f.MontoD,
  
          Cantidad: f.BalanceDevolucion,
          CantidadF: f.BalanceDevolucion,
          BalanceDevolucion: f.BalanceDevolucion,
  
          TasaCambioF: f.TasaCambio,
          TasaCambio: f.TasaCambio,
  
          Memo: '',
          PurchaseOrder: f.PurchaseOrder,
          Factura: f.Factura,
          IdUnit: f.IdUnit,
          UnitName: f.UnitName,
          IdProduct: f.IdProduct,
          CodigoProducto: f.CodigoProducto,
          NombreProducto: f.NombreProducto,
          IdUserEdit: userAuth?.IdUser,
          IdUserCreate: userAuth?.IdUser,
          NumeroIngreso: f.NumeroIngreso,
          IdIngreso: f.IdIngreso,
          IdPurchaseOrderDetail: f.IdPurchaseOrderDetail,
          IdTipoNotaCredito: null,
          TipoNotaCredito: null,
        };
  
        // 🔹 Backup de los valores originales
        nuevoDetalle._originalValues = {
          Cantidad: nuevoDetalle.Cantidad,
          TasaCambio: nuevoDetalle.TasaCambio,
          PrecioL: nuevoDetalle.PrecioL,
          PrecioD: nuevoDetalle.PrecioD,
          MontoL: nuevoDetalle.MontoL,
          MontoD: nuevoDetalle.MontoD,
          IdTipoNotaCredito: nuevoDetalle.IdTipoNotaCredito
        };
  
        dataNueva.push(nuevoDetalle);
      });
  
      let nuevoArreglo = detalles.concat(dataNueva);
      setSelectedFacturas([]);
      setDetalles(nuevoArreglo);
    }
  };
  
  const NuevaFilaVacia = () => {
    let newRow = [...detalles];
    let Id = (detalles.length + 1) * -1;
    let dataNueva = [
      {
        IdNotaCreditoDet: Id,
        IdNotaCreditoEnc: values.IdNotaCreditoEnc,
        IdEstado: 93,
        PurchaseOrder: "",
        Factura: "",
        IdProduct: 0,
        IdIngresoDetalle: 0,
        IdTipoIngreso: 0,
        IdUnit: 0,
        CantidadF: 0,
        PrecioFL: 0,
        PrecioFD: 0,
        MontoFL: 0,
        MontoFD: 0,
        TasaCambioF: 0,
        Cantidad: 0,
        PrecioL: 0,
        PrecioD: 0,
        MontoL: 0,
        MontoD: 0,
        TasaCambio: 0,
        IdUserEdit: userAuth.IdUser,
        IdUserCreate: userAuth.IdUser,
        NumeroIngreso: "",
        IdIngreso: 0,
        IdPurchaseOrderDetail: 0,
        IdTipoNotaCredito: 0,
      },
    ];

    newRow.push(dataNueva);
    let nuevoArreglo = detalles.concat(dataNueva);
    setDetalles(nuevoArreglo);
  };

  const EliminarDetalle = async () => {
    if (selected.some(item => item.IdNotaCreditoDet > 0)) {
      confirmDialog({
        message: "¿Está seguro que desea eliminar el detalle?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          setLoading(true);
          const nuevosDetalles = detalles.filter(detalle => !selected.some(item => item.IdNotaCreditoDet === detalle.IdNotaCreditoDet));
          const Ids = selected.filter(item => item.IdNotaCreditoDet > 0).map(item => item.IdNotaCreditoDet).join(',');
          const resp = await eliminarDetalles(Ids);
          toastShow(toast, "success", "Eliminado", 'Detalles eliminados correctamente');
          setTimeout(() => {            
            setLoading(false);
            setDetalles(nuevosDetalles);
            setSelected([]);
          }, 600);
        },
        reject: () => {},
      })
    } else {
      const idsAEliminar = selected.map(item => item.IdNotaCreditoDet);
      const nuevosDetalles = detalles.filter(
        detalle => !idsAEliminar.includes(detalle.IdNotaCreditoDet)
      );
      setDetalles(nuevosDetalles);
      setSelected([]);
    }
  };
  
  const AplicarNotaCredito = () => {
    let message = (
      <div>
        <span>¿Está seguro que desea aplicar la nota de crédito?</span>
        <br />
        <span>Al aplicarse afectara los ingresos seleccionados</span>
      </div>
    );
    confirmDialog({
      message: message,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        const detallesDev = detalles.map((i) => {
          return {
            IdIngresoDetalle: i.IdIngresoDetalle,
            Devolucion: i.Cantidad,
            FechaDevolucion: getDateTimeStringSQL(new Date(values.FechaEmisionStr)),
            IdUserDevolucion: userAuth.IdUser,
            Comentario: i.Memo,
            IdTipoNotaCredito: i.IdTipoNotaCredito,
            TasaCambio: i.TasaCambio,

            PrecioL: i.PrecioL,
            PrecioD: i.PrecioD,

            SubTotalL: i.PrecioL * i.Cantidad,
            SubTotalD: i.PrecioD * i.Cantidad,

            ISVL: (i.ISVProductoL / i.Ingreso) * i.Cantidad,
            ISVD: (i.ISVProductoD / i.Ingreso) * i.Cantidad,

            ISV18L: (i.ISV18ProductoL / i.Ingreso) * i.Cantidad,
            ISV18D: (i.ISV18ProductoD / i.Ingreso) * i.Cantidad,

            DescuentoL: (i.Descuento / i.Ingreso) * i.Cantidad,
            DescuentoD: (i.DescuentoD / i.Ingreso) * i.Cantidad,

            MontoL: i.MontoL,
            MontoD: i.MontoD,
            IdPurchaseOrderDetail: i.IdPurchaseOrderDetail,
            IdProducto: i.IdProduct,
          };
        });

        const datosEnviar = {
          Detalles: detallesDev,
          IdTipoIngreso: values?.IdTipoIngreso,
          IdNotaCreditoEnc: values?.IdNotaCreditoEnc,
        };

        const result = await AplicarNota(datosEnviar);

        let respuesta = result[0];
        if (respuesta?.ESTADO === 1) {
          toastShow(toast, "success", "Aplicada", respuesta?.MENSAJE);
          getValoresIniciales();
          getInfo();
        } else {
          toastShow(toast, "error", "Error", respuesta?.MENSAJE);
        }
      },
      reject: () => {},
    });
  };

  const columns = [
    {
      field: "IdNotaCreditoDet",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
    },
    {
      field: "CuentaDetalle",
      header: "Cuenta",
      headerEn: "Account",
      className: "large",
      editable: ({ data }) => {
        return habilitar && data?.IdNotaCreditoDet;
      },
      onChange: ({ state, data: rowData, value, label, api, items, oldValue }) => {
        let row = { ...rowData }
        let tempo = [...detalles]
        if (state?.IdCuenta !== oldValue?.IdCuenta) {
          if (selected.length > 0) {
            tempo.forEach((t) => {
              selected.forEach((s) => {
                if (t.IdNotaCreditoDet === s.IdNotaCreditoDet) {
                  s.IdCuenta = state?.IdCuenta
                  s.CuentaDetalle = state?.CuentaDetalle
                }
              })
            })
          }

          if (row.IdNotaCreditoDet) {
            row.IdCuenta = state?.IdCuenta
            row.CuentaDetalle = state?.CuentaDetalle
            const index = detalles.findIndex((detail) => detail.IdNotaCreditoDet === row.IdNotaCreditoDet)
            tempo[index] = row
          }
        } else {
          return
        }
        setSelected([])
        setDetalles(tempo)
      },
      width: 250,
      filter: true,
      value: "IdCuenta",
      label: "CuentaDetalle",
      items: cuentasDetalles,
      Format: "AutoComplete",
      flex: 1,
      minWidth: 500,
    },
    {
      field: "PurchaseOrder",
      header: "PO",
      className: "medium",
      // editable: habilitar,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNotaCreditoDet > 0) {
          setShowDialogReporte(true);
          setSelected([data]);
        }
      }
    },
    {
      header: "Factura",
      field: "Factura",
      className: "medium",
    },
    {
      field: "NumeroIngreso",
      header: "Numero Ingreso",
      className: "small",
    },
    {
      field: "CodigoProducto",
      header: "Codigo Producto",
      className: "small",
      editable: habilitar,
    },
    {
      field: "NombreProducto",
      header: "Producto",
      headerEn: "Product",
      className: "medium",
      editable: habilitar,
    },
    {
      header: "Tipo nota credito",
      headerEn: "",
      field: "TipoNotaCredito",
      className: "",
      Format: "AutoComplete",
      value: "IdTipoNotaCredito",
      items: tipoNotaCredito,
      label: "TipoNotaCredito",
      editable: (e) => {
        let row = e.data
        return habilitar && row?.IdNotaCreditoDet <= 0
      },
      onChange: ({ state, data, value, label, api, items, oldValue }) => {
        let row = { ...data };
        let tempo = [...detalles];
      
        const nuevoTipo = state?.IdTipoNotaCredito;
        const tipoAnterior = row?.IdTipoNotaCredito;
      
        const debeRestaurarValores = tipoAnterior && tipoAnterior > 0 && nuevoTipo !== tipoAnterior;
      
        if (nuevoTipo !== tipoAnterior) {
          if (selected.length > 0) {
            tempo.forEach((t) => {
              selected.forEach((s) => {
                if (t.IdNotaCreditoDet === s.IdNotaCreditoDet) {
                  s.IdTipoNotaCredito = nuevoTipo;
                  s.TipoNotaCredito = state?.TipoNotaCredito;
  
                  if (debeRestaurarValores && s._originalValues) {
                    s.Cantidad = s._originalValues.Cantidad;
                    s.TasaCambio = s._originalValues.TasaCambio;
                    s.PrecioL = s._originalValues.PrecioL;
                    s.PrecioD = s._originalValues.PrecioD;
                    s.MontoL = s._originalValues.MontoL;
                    s.MontoD = s._originalValues.MontoD;
                  }
    
                  if (nuevoTipo === 3) {
                    s.MontoD = 0;
                    s.PrecioD = 0;
                  }
                }
              });
            });
          }
      
          if (row.IdNotaCreditoDet) {
            row.IdTipoNotaCredito = nuevoTipo;
            row.TipoNotaCredito = state?.TipoNotaCredito;
      
            if (debeRestaurarValores && row._originalValues) {
              row.Cantidad = row._originalValues.Cantidad;
              row.TasaCambio = row._originalValues.TasaCambio;
              row.PrecioL = row._originalValues.PrecioL;
              row.PrecioD = row._originalValues.PrecioD;
              row.MontoL = row._originalValues.MontoL;
              row.MontoD = row._originalValues.MontoD;
            }
      
            if (nuevoTipo === 3) {
              row.MontoD = 0;
              row.PrecioD = 0;
            }
      
            const index = detalles.findIndex(
              (detail) => detail.IdNotaCreditoDet === row.IdNotaCreditoDet
            );
            tempo[index] = row;
          }
      
          setSelected([]);
          setDetalles(tempo);
        }
      },
    },
    {
      field: "Memo",
      header: "Memo",
      className: "XXlarge",
      editable: habilitar,
    },
    {
      field: "BalanceDevolucion",
      header: "Balance",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "Cantidad",
      header: "Cantidad",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      editable: (e) => {
        let row = e.data
        return habilitar && row?.IdTipoNotaCredito === 1;
      },
      onChange: (data) => {
        if (data.newValue) {
          let det = data.data;
      
          if (det.IdNotaCreditoDet < 0) {
            const cantidadOriginal = det._originalValues?.Cantidad ?? det.Cantidad;
      
            if (data.newValue > cantidadOriginal) {
              toastShow(toast, "warn", "Advertencia", "La cantidad no puede ser mayor a la cantidad original.");
              det.Cantidad = cantidadOriginal;
            } else {
              det.Cantidad = data.newValue;
              det.MontoD = det.IdTipoNotaCredito !== 3 ? data.newValue * det.PrecioD : 0;
              det.MontoL = data.newValue * det.PrecioL;
            }
      
          } else {
            const cantidadAnterior = det.Cantidad;
            const Balance = det?.BalanceDevolucion ?? cantidadAnterior;
            if (data.newValue > Balance) {
              toastShow(toast, "warn", "Advertencia", "La cantidad no puede ser mayor al balance disponible.");
              det.Cantidad = data?.oldValue;
            } else {
              det.Cantidad = data.newValue;
              det.MontoD = det.IdTipoNotaCredito !== 3 ? data.newValue * det.PrecioD : 0;
              det.MontoL = data.newValue * det.PrecioL;
            }
          }
      
          let tempo = [...detalles];
          const index = tempo.findIndex((d) => d.IdNotaCreditoDet === det.IdNotaCreditoDet);
          tempo[index] = det;
          setDetalles(tempo);
        }
      }
      
      
      
      
      
      // onChange: (data) => {
      //   if (data.newValue) {
      //     let det = data.data;
      //     det.Cantidad = data.newValue;
      //     det.MontoD = det.IdTipoNotaCredito !== 3 ? data.newValue * det.PrecioD : 0;
      //     det.MontoL = data.newValue * det.PrecioL;

      //     let tempo = [...detalles];
      //     const index = tempo.findIndex(
      //       (d) => d.IdNotaCreditoDet === det.IdNotaCreditoDet
      //     );
      //     tempo[index] = det;
      //     setDetalles(tempo);
      //   }
      // },
    },
    {
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
    },
    {
      field: "TasaCambio",
      header: "TasaCambio",
      className: "small",
      Format: "Decimal",
      editable: habilitar,
      onChange: (data) => {
        if (data.newValue) {
          let det = data.data;
          det.TasaCambio = data.newValue;
          let IdCurrency = values?.Currency?.IdCurrency || values?.IdCurrency;
          if (IdCurrency === 1) {
            det.PrecioL = (det.MontoD * data.newValue) / det.Cantidad;
            det.MontoL = det.MontoD * data.newValue;
          } else {
            if (det.IdTipoNotaCredito !== 3) {
              det.PrecioD = det.MontoL / data.newValue / det.Cantidad;
              det.MontoD = det.MontoL / data.newValue;
            } else {
              det.PrecioD = 0;
              det.MontoD = 0;
            }
          }
          let tempo = [...detalles];
          const index = tempo.findIndex(
            (d) => d.IdNotaCreditoDet === det.IdNotaCreditoDet
          );
          tempo[index] = det;
          setDetalles(tempo);
        }
      },
    },
    {
      field: "PrecioD",
      header: "Precio $",
      className: "Xsmall",
      Format: "Currency",
      editable: (e) => {
        let row = e.data
        return habilitar && row?.IdTipoNotaCredito === 2
      },
      onChange: (data) => {
        if (data.newValue) {
          let det = data.data;
          det.PrecioD = data.newValue;
          det.MontoD =
            det.IdTipoNotaCredito !== 3 ? data.newValue * det.Cantidad : 0;
          det.PrecioL = data.newValue * det.TasaCambio;
          det.MontoL = det.PrecioL * det.Cantidad;

          let tempo = [...detalles];
          const index = tempo.findIndex(
            (d) => d.IdNotaCreditoDet === det.IdNotaCreditoDet
          );
          tempo[index] = det;
          setDetalles(tempo);
        }
      },
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "MontoD",
      header: "Monto $",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      editable: habilitar,
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "PrecioL",
      header: "Precio L",
      className: "Xsmall",
      Format: "Currency",
      Frozen: true,
      alignFrozen: "right",
      editable: (e) => {
        let row = e.data
        return habilitar && row?.IdTipoNotaCredito === 2
      },
      onChange: (data) => {
        if (data.newValue) {
          let det = data.data;
          det.PrecioL = data.newValue;
          det.MontoL = data.newValue * det.Cantidad;
          if (det.IdTipoNotaCredito !== 3) {
            det.PrecioD = data.newValue / (det.TasaCambio || 1);
            det.MontoD = det.PrecioD * det.Cantidad;
          } else {
            det.PrecioD = 0;
            det.MontoD = 0;
          }

          let tempo = [...detalles];
          const index = tempo.findIndex((d) => d.IdNotaCreditoDet === det.IdNotaCreditoDet);
          tempo[index] = det;
          setDetalles(tempo);
        }
      },
    },
    {
      field: "MontoL",
      header: "Monto L",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
      editable: habilitar,
    },
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => {},
  };

  useEffect(() => {
    getValoresIniciales(selectedEnc);
  }, [selectedEnc]);

  useEffect(() => {
    let IdVendor = values?.CustomerName?.IdVendor || values?.IdVendor;
    if (IdVendor) {
      let IdCountry = values?.CustomerName?.IdCountry || values?.IdCountry;
      let cuenta
      if (IdCountry === 95) {
        cuenta = cuentas?.find((i) => i.IdAccount === 15);
      } else {
        cuenta = cuentas?.find((i) => i.IdAccount === 16);
      }

      setValues({
        ...values,
        IdCuentaDebito: cuenta,
        NombreCuenta: cuenta,
      })
    }
  }, [values?.CustomerName?.IdVendor, values?.IdVendor]);
  
  const cerrarDialog = () => {
    if(habilitar){
      confirmDialog({
        message: "¿Está seguro que desea salir sin guardar?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          setShowDialog(false);
          setSelectedEnc([])
          resetForm()
          setDetalles([])
          setHabilitar(true)
        },
        reject: () => {},
      });
    }else{
      setShowDialog(false);
      setSelectedEnc([])
      setHabilitar(true)
    }
  }

  return (
    <div>
      <Dialog
        visible={showDialog}
        onHide={() => cerrarDialog()}
        header={"Nota de Crédito de Proveedor"}
        style={{ width: "90vw", height: "90vh" }}
        maximizable
      >
        <Loader loading={loading} />
        <Toast ref={toast} />

        {/* ENCABEZADO */}
        <div className="d-flex flex-column">
          <Card
            contenido={
              <div className="d-flex">
                <div className="col-12">
                  {/* ------------------------- CAMPOS ----------------------- */}
                  <div className="d-flex flex-wrap align-items-start gap-2 mt-2">
                    {/* No. Nota */}
                    <span className=" field p-float-label">
                      <InputText
                        id="NumeroNota"
                        name="NumeroNota"
                        value={values?.NumeroNota}
                        onChange={handleInputChange}
                        style={{ fontWeight: "bold" }}
                        disabled={!habilitar}
                      />
                      <label htmlFor="NumeroNota">No. Nota</label>
                    </span>

                    <AutoCompleteDropdown
                      enable={habilitar && detalles?.length === 0}
                      value={values?.CustomerName}
                      items={proveedores}
                      field={"CustomerName"}
                      name={"CustomerName"}
                      handleInputChange={handleInputChange}
                      label={"Proveedor"}
                    />

                    {/* Fecha Emision*/}
                    <span className="p-float-label">
                      <Calendar
                        id="FechaEmisionSrt"
                        name="FechaEmisionSrt"
                        disabled={!habilitar}
                        onChange={(e) =>
                          handleInputChange(e, "FechaEmisionStr")
                        }
                        value={values?.FechaEmisionStr}
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        showIcon
                      />
                      <label htmlFor="FechaEmision">Fecha Emisión</label>
                    </span>

                    <AutoCompleteDropdown
                      enable={false}
                      value={values?.StatusName}
                      items={estados}
                      field={"StatusName"}
                      name={"StatusName"}
                      handleInputChange={handleInputChange}
                      label={"Estado"}
                    />

                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values?.Currency}
                      items={monedas}
                      field={"Currency"}
                      name={"Currency"}
                      handleInputChange={handleInputChange}
                      label={"Moneda"}
                    />

                    {/* Memo */}
                    <span className=" p-float-label d-flex">
                      <InputTextarea
                        disabled={!habilitar}
                        id="Memo"
                        name="Memo"
                        value={values?.Memo}
                        onChange={handleInputChange}
                        cols={56}
                        style={{ height: "3rem" }}
                      />
                      <label htmlFor="Memo">Memo</label>
                    </span>

                    <span className=" field p-float-label">
                      <InputNumber
                        disabled={!habilitar}
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        useGrouping={true}
                        id="Monto"
                        name="Monto"
                        style={{ width: "235px" }}
                        value={values?.Monto}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="Monto">Monto</label>
                    </span>

                    <span className=" field p-float-label">
                      <InputNumber
                        disabled={!habilitar}
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        useGrouping={true}
                        id="TasaCambio"
                        name="TasaCambio"
                        style={{ width: "261px" }}
                        value={values?.TasaCambio}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="TasaCambio">Tasa de Cambio</label>
                    </span>

                    <AutoCompleteDropdown
                      enable={habilitar && detalles?.length === 0}
                      value={values?.Inventario}
                      items={tipoIngresos}
                      field={"Inventario"}
                      name={"Inventario"}
                      handleInputChange={handleInputChange}
                      label={"Inventario"}
                    />

                    <div style={{ width: "30%" }}>
                      <AutoCompleteDropdown
                        enable={habilitar}
                        value={values?.NombreCuenta}
                        items={cuentas}
                        field={"NombreCuenta"}
                        name={"NombreCuenta"}
                        handleInputChange={handleInputChange}
                        label={"Cuenta Débito"}
                      />
                    </div>
                  </div>

                  {/* --------------------------BOTONES-----------------------  */}
                  <div className="d-flex flex-wrap gap-1 mb-2 mt-3">
                    <Button
                      icon="pi pi-pencil"
                      type="button"
                      onClick={() => setHabilitar(true)}
                      tooltip="Editar"
                      tooltipOptions={{ position: "top" }}
                      disabled={
                        values?.IdNotaCreditoEnc <= 0 ||
                        values?.IdStatus === 95 ||
                        values?.IdStatus === 96 ||
                        values?.IdStatus === 97
                      }
                    />

                    <Button
                      icon="pi pi-save"
                      type="button"
                      onClick={guardarNota}
                      tooltip="Guardar"
                      tooltipOptions={{ position: "top" }}
                      disabled={!habilitar || detalles?.length === 0}
                    />

                    <Button
                      icon="pi pi-times"
                      type="button"
                      className="p-button-danger"
                      onClick={() => EliminarDetalle()}
                      tooltip="Eliminar"
                      disabled={!habilitar || selected?.length === 0}
                      tooltipOptions={{ position: "top" }}
                    />
                    <Button
                      icon="pi pi-sync"
                      type="button"
                      onClick={() => getValoresIniciales()}
                      tooltip="Cargar"
                      tooltipOptions={{ position: "top" }}
                    />

                    <Button
                      icon="pi pi-book"
                      type="button"
                      onClick={() => {
                        confirmDialog({
                          message: "¿Está seguro que desea crear nueva nota?",
                          header: "Crear Nueva Nota",
                          icon: "pi pi-exclamation-triangle",
                          accept: () => {
                            getNuevaNota()
                          },
                        })
                      }}
                      tooltip="Nueva Nota"
                      tooltipOptions={{ position: "top" }}
                    />

                    <OverlayIngresos
                      selectedPcs={selectedFacturas}
                      setSelectedPCs={setSelectedFacturas}
                      IdTipoIngreso={ values.Inventario?.IdTipoIngreso || values?.IdTipoIngreso }
                      IdVendor={ values.CustomerName?.IdVendor || values?.IdVendor }
                      habilitar={habilitar}
                      agregarNuevaFila={agregarNuevaFila}
                    />

                    <Button
                      icon="ri-check-double-line"
                      onClick={() => AplicarNotaCredito()}
                      disabled={values?.IdNotaCreditoEnc <= 0 || values?.IdStatus === 97}
                      tooltip="Aplicar Nota"
                      tooltipOptions={{ position: "top" }}
                    />

                    {/* {userAuth?.IdRol === 1 && (
                      <Button
                        icon="ri-check-double-line"
                        label="Aplicar Nota"
                        type="button"
                        onClick={() => getValoresIniciales()}
                        tooltip="Aplicar Nota"
                        tooltipOptions={{ position: "top" }}
                        disabled={values?.IdStatus !== 95}
                      />
                    )} */}
                  </div>
                </div>
              </div>
            }
          />
        </div>

        {/* DETALLES */}
        <Card
          contenido={
            <div style={{ height: "56vh" }}>
              <AgGrid table={table} />
            </div>
          }
        />
      </Dialog>


      {showDialogReporte && (
        <OrdenesComprasReporte1
          showReporte={showDialogReporte}
          setShowReporte={setShowDialogReporte}
          selectedDetalle={selected}
          Language={Languaje}
          setLanguaje={setLanguaje}
        />
      )}
    </div>
  );
};

export default NotaCreditoProveedorCRUD;



  // const agregarNuevaFila = (infoIngreso) => {
  //   let newRow = [...detalles];

  //   let FacturaExistente = detalles.some((i) => infoIngreso.some((f) => f.IdIngresoDetalle === i.IdIngresoDetalle && f.Factura === i.Factura));

  //   if (FacturaExistente) {
  //     toastShow(toast, "error", "Error", "No se permiten valores repetidos");
  //   } else {
  //     let dataNueva = []
  //     infoIngreso.forEach((f) => {
  //       let Id = (detalles.length + dataNueva.length + 1) * (-1)
  //       dataNueva.push({
  //         IdNotaCreditoDet: Id,
  //         IdNotaCreditoEnc: values.IdNotaCreditoEnc,
  //         IdStatus: 75,
  //         IdIngresoDetalle: f.IdIngresoDetalle,
  //         IdTipoIngreso: values?.Inventario?.IdTipoIngreso || values?.IdTipoIngreso,

  //         PrecioFD: f.PrecioD,
  //         PrecioFL: f.PrecioL,
  //         PrecioD: f.PrecioD,
  //         PrecioL: f.PrecioL,

  //         MontoFD: f.MontoD,
  //         MontoFL: f.MontoL,
  //         MontoL: f.MontoL,
  //         MontoD: f.MontoD,

  //         Cantidad: f.Ingreso,
  //         CantidadF: f.Ingreso,

  //         TasaCambioF: f.TasaCambio,
  //         TasaCambio: f.TasaCambio,

  //         Memo: '',
  //         PurchaseOrder: f.PurchaseOrder,
  //         Factura: f.Factura,
  //         IdUnit: f.IdUnit,
  //         UnitName: f.UnitName,
  //         IdProduct: f.IdProduct,
  //         CodigoProducto: f.CodigoProducto,
  //         NombreProducto: f.NombreProducto,
  //         IdUserEdit: userAuth?.IdUser,
  //         IdUserCreate: userAuth?.IdUser,
  //         NumeroIngreso: f.NumeroIngreso,
  //         IdIngreso: f.IdIngreso,
  //         IdPurchaseOrderDetail: f.IdPurchaseOrderDetail,
  //         IdTipoNotaCredito: null,
  //         TipoNotaCredito: null
  //       })
  //       newRow.push(dataNueva)
  //       let nuevoArreglo = detalles.concat(dataNueva)
  //       setSelectedFacturas([])
  //       setDetalles(nuevoArreglo)
  //     })
  //   }
  // };
